import React from "react";
import {Navigate, Outlet} from "react-router-dom";
import {useUserContext} from "../context/AuthContext";

const AuthLayout = () => {
  const {isAuthenticated, isLoading} = useUserContext();

  if (isLoading) return null;

  if (isAuthenticated) return <Navigate to="/" replace />
    
  return (
    <section className="flex flex-1 justify-center items-center flex-col">
      <Outlet />
    </section>
  );
};

export default AuthLayout;